<form [formGroup]="deliveryForm" class="ps-flex-container-col">
  <h3
    *ngIf="plannedDelivery">{{'orders.overlays.createDeliveryNote.createDelivery' | translate}} {{plannedDelivery.PLANNED_DATE | date}}</h3>

  <mat-form-field appearance="fill">
    <mat-label>{{'orders.overlays.createDeliveryNote.deliveryNoteNr' | translate}}</mat-label>
    <input formControlName="deliveryNr" matInput required>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{'orders.overlays.createDeliveryNote.deliveryComment' | translate}}</mat-label>
    <input matInput formControlName="deliveryCommentControl">
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{'orders.overlays.createDeliveryNote.nrOfPieces' | translate}}</mat-label>
    <input formControlName="plannedCount" matInput required>
  </mat-form-field>

  <mat-form-field appearance="fill">
    <mat-label>{{'orders.overlays.createDeliveryNote.plannedDeliveryDate' | translate}}</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="plannedDate">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>

  <mat-checkbox *ngIf="!(plannedDelivery.PBO_SUBTYP_ID > 0)" formControlName="replacement" style="padding: 12px">
    {{'orders.overlays.createDeliveryNote.replacementDelivery' | translate}}
  </mat-checkbox>
</form>

<div>
  <button mat-button color="accent"
          (click)="dismiss()">{{'orders.overlays.createDeliveryNote.reject' | translate}}</button>
  <button mat-button color="accent" [disabled]="!deliveryForm.valid"
          (click)="submit()">{{'orders.overlays.createDeliveryNote.save' | translate}}</button>
</div>


